import React from 'react'

import { systemMatchesAllFilters } from '../helpers/systems'
import { useFiltersStore } from '../state/filtersStore'
import { I_SystemPost, useWpDataStore } from '../state/wpDataStore'

const getSystemValue = (system: I_SystemPost, acfName: string) => {
  const acf = system.acf ?? {}
  const raw = acf[acfName]
  if (raw && typeof raw === 'object' && 'value_new' in raw) {
    return raw.value_new
  }
  return 'bypass'
}

const formatAnswer = (v: unknown) =>
  v === true || v === 'yes'
    ? 'Yes'
    : v === false || v === 'no'
      ? 'No'
      : v === 'bypass'
        ? 'Bypass'
        : String(v ?? '—')

const LogicDebug = () => {
  const appliedFilters = useFiltersStore((state) => state.appliedFilters)
  const systemFilters = appliedFilters.filter((f) => f.applies_to === 'systems')
  const systems = useWpDataStore((state) => state.systems)

  return (
    <div className='logic-debug'>
      <p className='logic-debug__title'>Debug:</p>

      {systemFilters.length > 0 ? (
        <>
          <p>
            <p>User applied filters:</p>
            {systemFilters.map((f, index) => {
              const { acf_name, value } = f

              return (
                <p key={`${acf_name}-${index}`}>
                  {f.label}: {formatAnswer(value)}
                </p>
              )
            })}
          </p>
        </>
      ) : (
        <p>No user applied filters yet, all systems allowed in list.</p>
      )}

      {!systems?.length ? (
        <p>No systems loaded.</p>
      ) : (
        <ul className='logic-debug__list'>
          {systems.map((system) => {
            const isVisible = systemMatchesAllFilters(system, systemFilters)

            const mismatched = systemFilters.filter((f) => {
              const systemValue = getSystemValue(system, f.acf_name)

              if (systemValue === 'bypass') return false
              if (systemValue === undefined) return true

              const normalizedSystemValue =
                systemValue === 'yes'
                  ? true
                  : systemValue === 'no'
                    ? false
                    : systemValue

              const normalizedFilterValue =
                f.value === 'yes' ? true : f.value === 'no' ? false : f.value

              return (
                String(normalizedSystemValue) !== String(normalizedFilterValue)
              )
            })

            return (
              <li
                key={system.id}
                className={`logic-debug__item ${
                  isVisible
                    ? 'logic-debug__item--visible'
                    : 'logic-debug__item--hidden'
                }`}
              >
                <div>
                  <strong>
                    {system.title?.rendered ?? `System #${system.id}`} (
                    {isVisible ? 'Visible' : 'Not visible'})
                  </strong>
                </div>

                {isVisible && (
                  <div>All user applied filter matches system settings.</div>
                )}

                {mismatched.length > 0 && (
                  <div>
                    <div>Not visible because:</div>
                    {mismatched.map((f) => {
                      const systemValue = getSystemValue(system, f.acf_name)
                      const formatAnswer = (v: unknown) =>
                        v === true
                          ? 'Yes'
                          : v === false
                            ? 'No'
                            : String(v ?? '—')

                      return (
                        <div key={f.acf_name}>
                          User answered {f.label} - "{formatAnswer(f.value)}",
                          and system is set to "{formatAnswer(systemValue)}"
                        </div>
                      )
                    })}
                  </div>
                )}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export { LogicDebug }
